// extracted by mini-css-extract-plugin
export default {"text":"VMicuGa5tMp-BtvCB4I+ZQ==","markdown__heading":"DV3cksVMmf5APJBCCCwNYQ=="};